/**
 * Roadways Module - Entry Point
 *
 * @module roadways
 * @description Módulo de Vialidades - Red vial y defectos físicos
 *
 * @remarks
 * Este archivo se importa automáticamente en MapLayout para auto-registrar el módulo.
 * NO requiere modificar código del core.
 */

import { moduleRegistry } from '../../module-registry';
import { RoadwaysToolbarContent } from './components/RoadwaysToolbarContent';
import { RoadwaysTabbedPanel } from './components/panels/RoadwaysTabbedPanel';

/**
 * Auto-registro del módulo Roadways
 *
 * @remarks
 * Se ejecuta automáticamente al importar este archivo.
 * El módulo queda disponible para MapLayout y BottomToolbar.
 */
moduleRegistry.register({
  id: 'roadways',
  leftPanel: RoadwaysTabbedPanel,
  toolbar: {
    content: RoadwaysToolbarContent,
  },
  enabledByDefault: false,
  requiresRealtime: false,
});

/**
 * Exports públicos del módulo
 */
export { RoadwaysTabbedPanel } from './components/panels/RoadwaysTabbedPanel';
export { RoadwaysToolbarContent } from './components/RoadwaysToolbarContent';
export { useRoadSegments } from './hooks/useRoadSegments';
export { useRoadDefects } from './hooks/useRoadDefects';
export { useRoadwaysElementColorsStore } from './store/element-colors-store';

export type {
  RoadSegment,
  RoadSurface,
  RoadSegmentSubtype,
  RoadCondition,
  RoadDirectionality,
  CreateRoadSegmentDto,
  UpdateRoadSegmentDto,
} from './types/road-segment.types';

export type {
  RoadDefectReport,
  RoadDefectSubtype,
  DefectSeverity,
  DefectStatus,
  CreateRoadDefectDto,
  UpdateRoadDefectDto,
} from './types/road-defect.types';
